import React from 'react';
import { formatDate } from '@/lib/format';

// Print/PDF document shell — Architectural Luxury: ivory page, charcoal type, generous whitespace, no decoration.
export const BrandedDocument = ({ identity, title, subtitle, meta = [], confidential = false, children, footerNote }) => {
  const { legalName, brand, divisionName } = identity;
  return (
    <article className="alvora-doc" data-testid="branded-document">
      <header className="alvora-doc__header">
        <div className="alvora-doc__identity">
          {brand ? (
            <img src={brand.wordmark} alt={legalName} className="alvora-doc__wordmark" data-testid="document-wordmark" />
          ) : (
            <div className="alvora-doc__legal-only" data-testid="document-legal-name">{legalName}</div>
          )}
          {divisionName && <div className="alvora-doc__division">{divisionName}</div>}
        </div>
        <div className="alvora-doc__title-block">
          <h1 className="alvora-doc__title">{title}</h1>
          {subtitle && <div className="alvora-doc__subtitle">{subtitle}</div>}
          {confidential && <div className="alvora-doc__confidential" data-testid="document-confidential">Internal — Confidential</div>}
        </div>
      </header>
      {meta.length > 0 && (
        <dl className="alvora-doc__meta">
          {meta.map(([k, v]) => (
            <div key={k}><dt>{k}</dt><dd>{v ?? '—'}</dd></div>
          ))}
        </dl>
      )}
      <section className="alvora-doc__body">{children}</section>
      <footer className="alvora-doc__footer">
        <span>{legalName}</span>
        <span>{footerNote || `Generated ${formatDate(new Date())}`}</span>
      </footer>
    </article>
  );
};
